import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=3bfaf9a6&scoped=true&"
import script from "./CustomersTable.vue?vue&type=script&lang=js&"
export * from "./CustomersTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=3bfaf9a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfaf9a6",
  null
  
)

export default component.exports